import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";
import { useParams } from "react-router";

const UpdateProjectManagement = ({ Show, Hide, Title, projectData, getEditorProjectData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [description, setDescription] = useState("");
  const {studyId} = useParams()

  function replaceLastSegment(path, newSegment) {
    const parts = path.split('/');
    parts[parts.length - 1] = newSegment;
    return parts.join('/');
  }

  const updateProjectData = async () => {
    setButtonLoader(true)
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Project Data?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = projectData?._id;
        userData.studyId = studyId;
        userData.name = projectName;
        userData.description = description;
          userData.previousName = `${projectData?.path}/`;
          userData.currentName = `${replaceLastSegment(projectData?.path, projectName)}/`;
        let data = await editorProjectServices.updateProjectData(
          userData
        );
        setButtonLoader(false)
        if (data?.statusCode === 200) {
          getEditorProjectData();
          Hide()
        }
      }
    });
  };

  useEffect(() => {
    setProjectName(projectData?.name)
    setDescription(projectData?.description)
  }, [projectData]);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Project Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              onChange={(e) => setProjectName(e.target.value)}
              value={projectName}
              className="fontSize12"
              placeholder="Enter Project Name"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Description{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              onChange={(e) => setDescription(e.target.value)}
              value={description}
              className="fontSize12"
              placeholder="Enter Description"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={updateProjectData}
            disabled={buttonLoader || !projectName || !description}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              Title
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateProjectManagement;
